import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MkpPricingSchemeLinkContainer } from '../../../../../models/aggregates/mkp/mkp-pricing-scheme-link-container.model';


@Injectable({
  providedIn: 'root'
})
export class MkpPricingSchemeLinkService extends BaseApiTemplateService<MkpPricingSchemeLinkContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + "pricing-scheme-links/" + Core2Config.BACKOFFICE_EP_SUFFIX;
  readonly endpointPathGeneric = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + "pricing-scheme-links/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}